import React, {useState} from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../components/Button';
import TextInput from '../../components/TextInput';
import {getAllDocuments} from '../../services/documents';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import IconButton from '../../components/IconButton';
import Form from 'react-bootstrap/Form';
import Link from '../../components/Link';
 
import Select from '../../components/Select';
import { Controller, useForm } from 'react-hook-form';
 
import CaseFormModal from '../../components/Case/CaseFormModal';
import useModal from '../../hooks/useModal';
import GenericCard from '../../components/GenericCards/GenericCards';

interface Documents {
  id: number;
  paticipantID: string;
  date: string;
  type: string;
  topic: string;
  category: string;
  addedBy: string;
  note: string;
}

const DocumentSearch = () => {
  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
    getValues
  } = useForm({

  });

  const [
    showAddNewCaseModal,
    handleAddNewCaseShow,
    handleAddNewCaseClose,
  ] = useModal();

  const [isSearchResultVisible, setIsSearchResultVisible] = useState(false);
  const [filteredDocumentList, setFilteredDocumentList] = useState<Documents[]>([]);

  const handleSearchButtonClick = () => {
    const { Participant } = getValues();

    if (!Participant) {
      // If search term is empty, display the full case list
      setFilteredDocumentList(documentList);
      setIsSearchResultVisible(true);
    } else {
      // Filter the list based on the search term (both firstName and lastName)
      const filteredList = documentList.filter((documents: Documents) => {
        // Check if Name matches any part of the participant's name
        const participantMatches = !Participant || Participant.toLowerCase().split(" ").some((term: string) =>
          (documents.paticipantID.toLowerCase().includes(term))
        );

        return participantMatches;
      })
      setFilteredDocumentList(filteredList);
      setIsSearchResultVisible(true);
    }
  };

  const handleResetButtonClick = () => {
    reset(); // Reset all form inputs
    setValue('Participant', '');
    setIsSearchResultVisible(false);
  };

  const documentList = getAllDocuments();
  const handleSubmitCase = (formData: any) => {};

  const [archiveValue, setArchiveValue] = React.useState<string[]>([]);

  const handleArchiveChange = (event: any, values: string[]) => { 
    setArchiveValue(values);
    console.log('archiveValue', archiveValue);
  };

  return (
    <Container className={'cnd-custom-container px-0 mt-11'}>
      <Container className={'px-7 px-lg-0 mb-11 mb-lg-12'}>
        <Row>
          <Col className={'col-12 col-lg-12'}>
            <h2 className={'h2 text-sm-20-lg-24 mb-7 mb-lg-11'}>
              Document Search
            </h2>
          </Col>
        </Row>
        <Row className="mt-8">
           <Col className="col-12 col-lg-7 p-2">

              <h5 className="text-sm-20-lg-24">Select Search Option <span className="text-fs-6 fw-light">(Only one option at a time)</span></h5>
              <Row className="mt-4">
              <Col className="col-12 p-1">
              <Controller
                name={'Name'}
                control={control}
                render={({ field }) => (
                  <TextInput
                    placeholder="Name"
                    isInvalid={!!errors.Name}
                    {...field}
                  />
                )}
              />
              {errors.Name && (
                <div className="error-message">
                  <span>{errors.Name.message}</span>
                </div>
              )}
              </Col>
             <Col className="col-12 p-1">
              <Controller
                name={'SSN'}
                control={control}
                render={({ field }) => (
                  <TextInput
                    placeholder="SSN"
                    isInvalid={!!errors.SSN}
                    {...field}
                  />
                )}
              />
              {errors.SSN && (
                <div className="error-message">
                  <span>{errors.SSN.message}</span>
                </div>
              )}
           </Col>
           <Col className="col-12 p-1">
            <Controller
              name={'EID'}
              control={control}
              render={({ field }) => (
                <TextInput
                  placeholder="EID"
                  isInvalid={!!errors.EID}
                  {...field}
                />
              )}
            />
            {errors.EID && (
              <div className="error-message">
                <span>{errors.EID.message}</span>
              </div>
            )}
          </Col>
          <Col className="col-12 p-1">
            <Controller
              name={'AccessID'}
              control={control}
              render={({ field }) => (
                <TextInput
                  placeholder="Access ID"
                  isInvalid={!!errors.AccessID}
                  {...field}
                />
              )}
            />
            {errors.Name && (
              <div className="error-message">
                <span>{errors.AccessID.message}</span>
              </div>
            )}
          </Col>
          </Row>
          </Col>

       <Col className="col-12 col-lg-5 p-1">
        <Row className={'m-0 p-0'}>
          <h5 className="text-sm-20-lg-24">At Your Fingertips</h5>
          <Col>
           <Container className="mt-3 p-10 border border-info rounded-1 col-lg-12">
              <Link rightIcon={light('chevron-right')}
                      className={'border-bottom py-4 '}
                      href="#/case-list"
                      isAlignAtEnd >
                        <h6 className="text-fs-6 mb-0 fw-normal  ">Case List</h6>
              </Link>
              <Link rightIcon={light('chevron-right')}
                      href="#/participant-access"
                      isAlignAtEnd >
                        <h6 className="text-fs-6 mb-0 fw-normal ">Participant Access</h6>
              </Link>
            </Container>
          </Col>
        </Row>
      </Col>
      </Row>
        <section className="py-11 py-lg-12 d-flex flex-column flex-lg-row">
          <Button
            className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1 reset-button"
            variant="primary-outline"
            type="button"
            onMouseDown={handleResetButtonClick}
          >
            Reset
          </Button>
          <Button
            variant="primary"
            className="order-1 order-lg-2 search-button"
            type="button"
            onMouseDown={handleSearchButtonClick}
          >
            Search
          </Button>
          <span></span>
        </section>

        {isSearchResultVisible && (
          <div>
            <div className="pt-8 px-5 pb-10">
              Upload request for the last 18 months are displayed. Once an
              uploaded document is received it will be reviewed and processed.
            </div>
            <GenericCard
              variant={'white'}
              className={'mt-5 case-search-result'}
            >
              <Container className={'px-0 py-0'}>
                <Row
                  className={
                    'd-none d-lg-flex mt-0 pb-5 border-bottom-light-gray-2px text-fs-6'
                  }
                >
                  <Col lg={1}>
                    <div className={'d-flex align-items-center'}>Submitted</div>
                  </Col>
                  <Col lg={1}>
                    <div className={'d-flex align-items-center'}>
                      Participant ID
                    </div>
                  </Col>
                  <Col lg={1}>
                    <div className={'d-flex align-items-center'}>Type</div>
                  </Col>
                  <Col lg={2}>
                    <div className={'d-flex align-items-center'}>Topic</div>
                  </Col>
                  <Col lg={2}>
                    <div className={'d-flex align-items-center'}>Category</div>
                  </Col>
                  <Col lg={2}>
                    <div className={'d-flex align-items-center'}>Added By</div>
                  </Col>
                  <Col lg={2}>
                    <div className={'d-flex align-items-center'}>Note</div>
                  </Col>
                  <Col lg={1}></Col>
                </Row>

                {/* Table body */}
                {filteredDocumentList && filteredDocumentList.map((docItem, index) => (

                      <Row
                        className={
                          'my-5 pb-5 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                        }
                      >
                        <Col lg={1} className="d-flex d-lg-block">
                          <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                            }
                          >
                            Submitted
                          </h2>
                          <span className={'text-end w-100'}>
                            {docItem.date}
                          </span>
                        </Col>
                        <Col lg={1} className="d-flex d-lg-block">
                          <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                            }
                          >
                            Participant ID
                          </h2>
                          <span className={'text-end w-100'}>
                            {docItem.paticipantID}
                          </span>
                        </Col>
                        <Col lg={1} className="d-flex d-lg-block">
                          <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                            }
                          >
                            Type
                          </h2>
                          <span className={'text-end w-100'}>
                            {docItem.type}
                          </span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                            }
                          >
                            Topic
                          </h2>
                          <span className={'text-end w-100'}>
                            {docItem.topic}
                          </span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                            }
                          >
                            Category
                          </h2>
                          <span className={'text-end w-100'}>
                            {docItem.category}
                          </span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                            }
                          >
                            Added by
                          </h2>
                          <span className={'text-end w-100'}>
                            {docItem.addedBy}
                          </span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                            }
                          >
                            Note
                          </h2>
                          <span className={'text-end w-100'}>
                            {docItem.note}
                          </span>
                        </Col>
                        <Col lg={1} className={'d-flex d-lg-block'}>
                          <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                            }
                          >
                            Document
                          </h2>
                          <span className={'text-end w-100'}>
                          <IconButton
                            variant="secondary-shadow"
                            icon={light('file')}
                            link={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                            target={'_blank'}
                            style={{
                              backgroundColor: '#9DB4C04D',
                              boxShadow: 'none',
                            }}
                          />
                          </span>
                        </Col>
                      </Row>

                  ))}
              </Container>
            </GenericCard>
          </div>
        )}
      </Container>
    </Container>
  );
}

export default DocumentSearch